import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { QueovalDateTime, Recipient, Select } from '../models';
import { DocumentGeneric, DocumentModel, LinkedElement } from '../models/document/document.model';
import { Historique, HistoriqueModel, HistoryMode } from '../models/historique/historique.model';
import { CoreService, HttpService } from '../services';
import { ToastService } from '../toast';

@Component({
  selector: 'q-related-documents',
  templateUrl: './related-documents.component.html',
  styleUrls: ['./related-documents.component.css']
})


/**
 * Composant pour la gestion des documents associés (par exemple à un stage)
 */
export class RelatedDocumentComponent implements OnInit {

  //#region propriétés publiques

  /**
   * Ensemble sur lequel les documents sont associés 
   */
  public Groupe: string;

  /**
   * Type de document
   */
  public Type: string;

  /**
   * Liste des documents
   */
  public ListDoc: Array<DocumentGeneric> = new Array<DocumentGeneric>();

  public idPere: string;

  public SelectedList: Array<Recipient> = new Array<Recipient>();
  public lstIdentSelected: string[] = [];
  //#endregion


  //#region input / output

  /**
   * Liste des groupes existants actuellement :
   * STAGE
   */
  @Input('Groupe') set SetGroupe(value: string) {
    this.Groupe = value;
    /*this.InitDocuments();*/
  }
  /**
   * Liste des élèments sélectionnés :
   */
  @Input('SelectedElements') set SetElement(value: string[]) {
    this.lstIdentSelected = value;
    /*this.InitDocuments();*/
  }

  /**
   * Liste des types existants actuellement :
   * COURRIER
   * CVT
   * DEVIS
   * CONTRAT
   */
  @Input('Type') set SetType(value: string) {
    this.Type = value;
    /*this.InitDocuments();*/
  }

  /**
  * Ident du composant parent (idpere)
  * identStage
  */
  @Input('Ident') set SetIdPere(value: string) {
    this.idPere = value;
    /*this.InitDocuments();*/
  }

  /**
   * List des personnes CLIENT ou CONTACT sélectionnés
   */
  @Input('List') set SetSelectedList(value: Recipient[]) {
    this.SelectedList = value;
    
    
  }

  @Output('SendDoc') sendDoc: EventEmitter<DocumentGeneric> = new EventEmitter<DocumentGeneric>();



  //#endregion

  //#region Constructeur
  constructor(
    public indParam: CoreService,
    protected domSanitizer: DomSanitizer,
    protected http: HttpService,
    protected toast: ToastService,
  ) { }

  //#endregion

  ngOnInit(): void {
    this.InitDocuments();
  }


  //#region public function
  public InitDocuments(): void {
    if (this.SelectedList && this.Type && this.idPere && this.Groupe && this.lstIdentSelected) {
      this.GetDocuments();
    }
  }

  /**
   * Récupère la liste complète des documents associés
   **/
  public GetDocuments(): void {
    // uniquement si les 2 inputs sont renseignés : Groupe + Type
    if (this.Groupe && this.Type) {
      this.http.getHttp<DocumentModel>(`${this.indParam.AppParams.apiUrl}api/document/${this.Groupe}/${this.Type}/`).subscribe(
        (data: DocumentModel) => {
          this.ListDoc = data.ListDocument;
          this.ShowRelatedDoc();
        });
    }

  }

  /**
   * Affichage des documents avec la liste des éléments liés
   **/
  public ShowRelatedDoc(): void {
    //recupere le type de document avant
    const model: DocumentModel = new DocumentModel();
    model.Mode = "AFFECT_LIST_ELEMENT";
    model.ListDocument = this.ListDoc;
    model.IdPere = this.idPere;
    model.RecipientList = this.SelectedList;
    model.Type = this.Type;
    if (model.ListDocument && model.IdPere && model.RecipientList && model.Type) {
      this.http.postHttp<DocumentModel>(`${this.indParam.AppParams.apiUrl}api/document/`, model).subscribe(
        (data: DocumentModel) => {
          // Mise à jour de la liste
          this.ListDoc = data.ListDocument;
          if (this.lstIdentSelected.length > 0) {

            this.ListDoc.forEach(x => {
              this.lstIdentSelected.forEach(y => {
                if (x.Ident == y) {
                  x.IsSelected = true;
                }
              })
            })

          }
          
        });
    }

  }

  /**
   * Retourne le titre selon le type de document
   **/
  public GetTitle(): string {
    switch (this.Type) {
      case 'COURRIER':
        return 'Courriers';
      case 'CVT':
        return 'Conventions';
      case 'DEVIS':
        return 'Devis';
      case 'CONTRAT':
        return 'Contrats';
      default:
        return '';
    }
  }

  // Liste des elements selectionnés pour le tooltip
  public GetListElement(listElementLinked: Array<LinkedElement>): string {
    let elements: string = '';
    if (listElementLinked) {
      listElementLinked.forEach((item: LinkedElement) => {
        elements = item && item.Text ? elements ? `${elements}\n${item.Text}` : item.Text : elements;
      });
    }
    return elements;
  }

  /**
   * Emit du document sélectionné / déselectionné au composant parent
   * @param document
   */
  public EmitDoc(document: DocumentGeneric) {
    this.sendDoc.emit(document);
  }

  //#enregion


}


